module.exports = __webpack_public_path__ + "static/img/american_credit_accounts_receivable1.e151a8a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/american_credit_accounts_receivable1.jpeg
// module id = 1643
// module chunks = 5